import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "toggle" }
const _hoisted_2 = { class: "toggle__text" }
const _hoisted_3 = {
  key: 0,
  class: "toggle__label"
}
const _hoisted_4 = {
  key: 1,
  class: "toggle__help"
}
const _hoisted_5 = { class: "inline-flex justify-start items-center" }
const _hoisted_6 = { class: "toggle__switch-container" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "toggle__switch" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("label", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["flex flex-row", { 'justify-between': _ctx.label }])
    }, [
      _createElementVNode("div", _hoisted_2, [
        (_ctx.label)
          ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(_ctx.label), 1))
          : _createCommentVNode("", true),
        (_ctx.helpText)
          ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(_ctx.helpText), 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_5, [
        (_ctx.unselectedLabel)
          ? (_openBlock(), _createElementBlock("p", {
              key: 0,
              class: _normalizeClass(["mr-2 font-robotoBold", { 'text-cebai-grey-dark': _ctx.value }])
            }, _toDisplayString(_ctx.unselectedLabel), 3))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_6, [
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.value) = $event)),
            class: "toggle__input",
            type: "checkbox"
          }, null, 512), [
            [_vModelCheckbox, _ctx.value]
          ]),
          _hoisted_7
        ]),
        (_ctx.selectedLabel)
          ? (_openBlock(), _createElementBlock("p", {
              key: 1,
              class: _normalizeClass(["ml-2 font-robotoBold", { 'text-cebai-grey-dark': !_ctx.value }])
            }, _toDisplayString(_ctx.selectedLabel), 3))
          : _createCommentVNode("", true)
      ])
    ], 2)
  ]))
}